__turbopack_context__.v({
  "avatar": "detail-drawer-module-scss-module__hOFRdG__avatar",
  "avatarImage": "detail-drawer-module-scss-module__hOFRdG__avatarImage",
  "avatarPlaceholder": "detail-drawer-module-scss-module__hOFRdG__avatarPlaceholder",
  "bodyHost": "detail-drawer-module-scss-module__hOFRdG__bodyHost",
  "closeButton": "detail-drawer-module-scss-module__hOFRdG__closeButton",
  "dragHandleWrap": "detail-drawer-module-scss-module__hOFRdG__dragHandleWrap",
  "footer": "detail-drawer-module-scss-module__hOFRdG__footer",
  "footerActionButton": "detail-drawer-module-scss-module__hOFRdG__footerActionButton",
  "footerActions": "detail-drawer-module-scss-module__hOFRdG__footerActions",
  "footerMobile": "detail-drawer-module-scss-module__hOFRdG__footerMobile",
  "header": "detail-drawer-module-scss-module__hOFRdG__header",
  "headerMobile": "detail-drawer-module-scss-module__hOFRdG__headerMobile",
  "headerRow": "detail-drawer-module-scss-module__hOFRdG__headerRow",
  "headerText": "detail-drawer-module-scss-module__hOFRdG__headerText",
  "overlayDesktop": "detail-drawer-module-scss-module__hOFRdG__overlayDesktop",
  "overlayMobile": "detail-drawer-module-scss-module__hOFRdG__overlayMobile",
  "savingOverlay": "detail-drawer-module-scss-module__hOFRdG__savingOverlay",
  "scrollContent": "detail-drawer-module-scss-module__hOFRdG__scrollContent",
  "sheetBody": "detail-drawer-module-scss-module__hOFRdG__sheetBody",
  "sheetContent": "detail-drawer-module-scss-module__hOFRdG__sheetContent",
  "sheetContentDesktop": "detail-drawer-module-scss-module__hOFRdG__sheetContentDesktop",
  "sheetContentMobile": "detail-drawer-module-scss-module__hOFRdG__sheetContentMobile",
  "subtitle": "detail-drawer-module-scss-module__hOFRdG__subtitle",
  "title": "detail-drawer-module-scss-module__hOFRdG__title",
});
